module.exports = __webpack_public_path__ + "img/KEY.60abc9a5.svg";